import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import SingleFilter from './SingleFilter';
import clsx from 'clsx';
import { filterItems } from './helper';

const arrowDown = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-arrow-down';
const closeIcon = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-close';
const minimumLocations = 6;

const RadioButtonComponent = ({
  text,
  index,
  selectedRadioButton,
  setSelectedRadioButton,
  setNumberOfSelectedCheckboxes,
}) => {
  const radioClicked = (index) => {
    selectedRadioButton === -1 && setNumberOfSelectedCheckboxes((prev) => ++prev);
    setSelectedRadioButton(index);
  };

  return (
    <div onClick={() => radioClicked(index)} className="filters__modal-body_category-filters_radio">
      <div className={clsx('radio-container', index === selectedRadioButton && 'selected')}>
        <div className="radio-container--inner"></div>
      </div>
      <span className="radio-content">{text}</span>
    </div>
  );
};

const FiltersModal = ({
  allFilters,
  setAllFilters,
  filtersData,
  showModal,
  setModalShow,
  t,
  numberOfSelectedCheckboxes,
  setNumberOfSelectedCheckboxes,
  setFilteredItems,
  items,
  selectedRadioButton,
  setSelectedRadioButton,
  setSelectedLocationCard,
  setSelectedMapCard,
  setLeftSideComponentToggle,
  hideTimings,
}) => {
  let { branchServices, locations, branchTypes } = filtersData;

  // Conditional Rendering
  const shouldRenderBranchServices = Array.isArray(branchServices) && branchServices.length > 0;
  const shouldRenderLocations = Array.isArray(locations) && locations.length > 0;
  const shouldRenderBranchTypes = Array.isArray(branchTypes) && branchTypes.length > 0;

  const locationsArray = shouldRenderLocations ? locations.length > minimumLocations ? locations.slice(0, minimumLocations) : locations : [];

  // We want to do pagination for the location in case they are more than 6;
  const [paginatedLocations, setPaginatedLocations] = useState(locationsArray);
  const showAllLocationsClick = () => {
    setPaginatedLocations(locations);
  };

  const clearFiltersClick = () => {
    setSelectedRadioButton(-1);
    setAllFilters({
      servicesFilter: [],
      locationFilter: [],
      bankingExperienceFilter: [],
    });
    setNumberOfSelectedCheckboxes(0);
    setFilteredItems(items);
  };

  const showResultsClick = () => {
    setModalShow(false);
    filterItems(
      items,
      allFilters,
      setFilteredItems,
      selectedRadioButton,
      setSelectedLocationCard,
      setSelectedMapCard,
      setLeftSideComponentToggle
    );
  };

  return (
    <Modal
      show={showModal}
      onHide={() => setModalShow(false)}
      aria-labelledby="contained-modal-title-vcenter"
      backdropClassName="filters__modal--backdrop"
      contentClassName="filters__modal--content"
      className="filters__modal"
      centered
    >
      <div className="filters__modal-header">
        <h4 className="filters__modal-header_heading">{t('moreOptions')}</h4>
        <img onClick={() => setModalShow(false)} src={closeIcon} alt="close" />
      </div>
      <div className="filters__modal-body">
        {shouldRenderBranchServices && (
          <div className="filters__modal-body_category">
            <div className="filters__modal-body_category-heading">{t('services')}</div>
            <div className="filters__modal-body_category-filters">
              {branchServices.map((item, index) => {
                return (
                  <SingleFilter
                    allFilters={allFilters}
                    setAllFilters={setAllFilters}
                    key={index}
                    rounded={false}
                    data={item}
                    setNumberOfSelectedCheckboxes={setNumberOfSelectedCheckboxes}
                    type="services"
                  />
                );
              })}
            </div>
          </div>
        )}
        {shouldRenderLocations && (
          <div className="filters__modal-body_category">
            <div className="filters__modal-body_category-heading">{t('location')}</div>
            <div className="filters__modal-body_category-filters">
              {paginatedLocations.map((item, index) => {
                return (
                  <SingleFilter
                    allFilters={allFilters}
                    setAllFilters={setAllFilters}
                    key={index}
                    rounded={false}
                    data={{
                      ...item,
                      fields: {
                        title: item?.fields?.city,
                      },
                    }}
                    setNumberOfSelectedCheckboxes={setNumberOfSelectedCheckboxes}
                    type="location"
                  />
                );
              })}
            </div>
            {locations.length !== paginatedLocations.length && (
              <div role="button" onClick={showAllLocationsClick} className="show-locations">
                <span>{t('show-all-locations')}</span>
                <img src={arrowDown} alt="arrow-down" />
              </div>
            )}
          </div>
        )}
        {shouldRenderBranchTypes && (
          <div className="filters__modal-body_category">
            <div className="filters__modal-body_category-heading">{t('bankingExperiences')}</div>
            <div className="filters__modal-body_category-filters">
              {branchTypes.map((item, index) => {
                return (
                  <SingleFilter
                    allFilters={allFilters}
                    setAllFilters={setAllFilters}
                    key={index}
                    rounded={false}
                    data={item}
                    setNumberOfSelectedCheckboxes={setNumberOfSelectedCheckboxes}
                    type="bankingExperience"
                  />
                );
              })}
            </div>
          </div>
        )}
        {!hideTimings && (
          <div className="filters__modal-body_category">
            <div className="filters__modal-body_category-heading">{t('timings')}</div>
            <div className="filters__modal-body_category-filters_radios">
              <RadioButtonComponent
                setNumberOfSelectedCheckboxes={setNumberOfSelectedCheckboxes}
                setSelectedRadioButton={setSelectedRadioButton}
                selectedRadioButton={selectedRadioButton}
                index={0}
                text={t('nowOpen')}
              />
              <RadioButtonComponent
                setNumberOfSelectedCheckboxes={setNumberOfSelectedCheckboxes}
                setSelectedRadioButton={setSelectedRadioButton}
                selectedRadioButton={selectedRadioButton}
                index={1}
                text={t('24-7')}
              />
              <RadioButtonComponent
                setNumberOfSelectedCheckboxes={setNumberOfSelectedCheckboxes}
                setSelectedRadioButton={setSelectedRadioButton}
                selectedRadioButton={selectedRadioButton}
                index={2}
                text={t('closedTemporarily')}
              />
            </div>
          </div>
        )}
      </div>
      <div
        className={clsx(
          'filters__modal-footer',
          numberOfSelectedCheckboxes > 0 && 'filters__modal-footer_up'
        )}
      >
        <div role="button" onClick={clearFiltersClick} className="clear-filters">
          {t('clearAll')}
        </div>
        <button
          className={clsx(
            'button',
            'button-contained-primary',
            numberOfSelectedCheckboxes === 0 && 'button-disabled'
          )}
          onClick={showResultsClick}
          disabled={numberOfSelectedCheckboxes === 0}
        >
          {t('showResults')}
        </button>
      </div>
    </Modal>
  );
};

export default FiltersModal;
